module.exports = __webpack_public_path__ + "img/WESicon5.19a5b118.png";